import { render, staticRenderFns } from "./propertyTile.vue?vue&type=template&id=f8ec70ba&"
import script from "./propertyTile.vue?vue&type=script&lang=js&"
export * from "./propertyTile.vue?vue&type=script&lang=js&"
import style0 from "./propertyTile.vue?vue&type=style&index=0&id=f8ec70ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports